import React from 'react'
import {OcAppBarState} from '../Model/OcAppBarState'
import {definedContextValueHookFactory} from '@oc/hooks'

const OcAppBarStateContext = React.createContext<OcAppBarState | null>(null)

export const useOcAppBarState = definedContextValueHookFactory(OcAppBarStateContext, 'OcAppBarStateContext')

export function OcAppBarStateContextProvider({children}: React.PropsWithChildren) {
    const [state] = React.useState(new OcAppBarState())
    return <OcAppBarStateContext.Provider value={state}>{children}</OcAppBarStateContext.Provider>
}
